<div *ngIf="this.forgotPasawordStatus===32">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow" [hidden]="this.actualRegisterViewStep === 'step11'">
            <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
            ¿Olvidaste tu contraseña?
        </div>
    </div>
    <div class="basicrow f-reg f-black roboto-r m-top-i text-justify">
        Por favor responde las preguntas de seguridad previamente configuradas en tu cuenta de acceso.
    </div>

    <!--<div ng-repeat="challengeQuestion in vm.challengeQuestions track by $index">
        <div class="basicrow m-top-i">
            <label class="label-f">{{challengeQuestion.question}}</label>
            <div class="basicrow">
                <input id="anwser_{{$index}}" class="inp-f">
            </div>
        </div>
    </div>-->
    <div class="basicrow m-top-i">
        <label class="label-f">{{this.challengeQuestions[0].question}}</label>
        <div class="basicrow">
            <input type="password" [(ngModel)]="this.anwser0" class="inp-f" autocomplete="off">
        </div>
    </div>

    <div class="basicrow m-top-i">
        <label class="label-f">{{this.challengeQuestions[1].question}}</label>
        <div class="basicrow">
            <input type="password" [(ngModel)]="this.anwser1" class="inp-f" autocomplete="off">
        </div>
    </div>

    <div class="basicrow m-top-i">
        <a (click)="this.getpasswordrecovery()" class="btns red vcenter">
            <span class="tabcell">
                Recuperar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
  </div>
